<app-spinner *ngIf="isLoading" placement="full-page" size="34px"></app-spinner>

<app-page-wrapper scrollable="true">
  <div class="subscribe-wrapper">
    <div class="subscribe-header" [hidden]="isLoading">
      <div class="label">Subscribe</div>
      <div class="header">{{ subscription.name }} <span class="price">$499.00</span></div>
      <div class="description">A year of access to TailOne services. Renews annually</div>
    </div>

    <!-- Stripe Payment Element mounts here -->
    <div #paymentInfo id="payment-element" [hidden]="isLoading" class="payment-element"></div>

    <div class="payment-secure-wrapper" *ngIf="!isLoading">
      <div class="message">Payments Secured via Stripe</div>
      <div class="icon">
        <app-svg-loader height="32px" url="assets/logos/third-party/stripe.svg"></app-svg-loader>
      </div>
    </div>

    <app-primary-btn (click)="onSubmit()" [hidden]="isLoading" [isLoading]="isProcessingPayment" [disabled]="isProcessingPayment" gradient="true">
      Subscribe
    </app-primary-btn>
  </div>
</app-page-wrapper>